<form>
  <div class="form-row">
    <div class="col-md-12 m-b-20">
      <div class="row pt-lg-3">
        <div class="col-12 col-md-12 col-lg-12 col-sm-12">
          <span class="note font-16 d-none d-lg-block d-md-block d-xl-block" >
             {{translationScope+'.instructions.identity_verification_form.identity_verification_form_initial' | transloco}}
            <br>
            <br>
            {{translationScope+'.instructions.identity_verification_form.identity_verification_form_middle' | transloco}}
            <br>
            <br>
            {{translationScope+'.instructions.identity_verification_form.identity_verification_form_last' | transloco}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Identity Proof -->
  <div class="form-row">
    <div class="col-md-12">
      <div class="input-item-edit required">
        <label class="text-uppercase" for="upload-badge-img" >{{translationScope+'.form.id_verification.label' | transloco}}</label>
        <div class="row align-items-center">
          <div class="col-md-6 col-sm-12">
            <div class="input-item-edit required">
              <ng-select
                [items]="identityTypes"
                [readonly]="isTabReadOnly"
                bindLabel="label"
                bindValue="value"
                [placeholder]="translationScope+'.form.id_verification.placeholder' | transloco"
                (clear)="onDocumentTypeClear()"
                (change)="onDocumentTypeSelect($event?.value)">
              </ng-select>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 align-self-center">
            <img class="secure-icon" src="assets/images/secure-icon.jpg" alt="">
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!selectedIdentityType">
      <ng-container *ngIf="kycDocuments">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table">
              <tbody>
                <tr *ngFor="let document of kycDocuments, let i = index">
                  <th>
                    <!-- <img *ngIf="isImage(file.type)" class="image-view" [ngfSrc]="file" alt="Live file"> -->
                    <img  class="image-view"
                      src="https://cdn0.iconfinder.com/data/icons/document-file-types/512/doc-512.png" alt="">
                  </th>
                  <!-- <td>{{file.providerId}}</td> -->
                  <td>{{document.type}}</td>
                  <td>{{document.identityType}}</td>
                  <td>{{document.documentSide}}</td>
                  <td>{{document.status}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngIf="selectedIdentityType">
    <div  class="row mb-3">
      <div class="col-12">
        <h5 class="text-uppercase">{{translationScope+'.form.id_verification.label_certificate' | transloco}}(JPG {{translationScope+'.or' | transloco}} PNG)</h5>
      </div>
    </div>
    <div class="row mb-5">
      <div *ngIf="selectedIdentityType" class="col-6 col-md-5">
        <div ngfDrop selectable [(file)]="idDocumentFront" [accept]="'image/jpeg,image/png'"
        (fileChange)="onDocumentFrontSelect($event)" class="document-front">

          <img *ngIf="!!idDocumentFront; else uploadIcon" [ngfSrc]="idDocumentFront" class="document" />

        </div>
        <p class="text-center">{{translationScope+'.frontpage' | transloco}} (JPG {{translationScope+'.or' | transloco}} PNG)</p>
      </div>

      <div class="col-6 col-md-5" *ngIf="selectedIdentityType === identityType.DRIVER_LICENSE">
        <div ngfDrop selectable [(file)]="idDocumentBack" [accept]="'image/jpeg,image/png'"
        (fileChange)="onDocumentBackSelect($event)" class="document-back">
          <img *ngIf="!!idDocumentBack; else uploadIcon" [ngfSrc]="idDocumentBack" class="document" />
        </div>
        <p class="text-center">{{translationScope+'.backpage' | transloco}} (JPG {{translationScope+'.or' | transloco}} PNG)</p>
      </div>
    </div>


    <div class="row mb-3">
      <div class="col-12"> <h5 class="text-uppercase">{{translationScope+'.form.id_verification.label_address' | transloco}}(PDF, JPG {{translationScope+'.or' | transloco}} PNG)</h5> </div>
    </div>

    <div class="row mb-3">
      <div *ngIf="selectedIdentityType" class="col-6 col-md-5">
        <div ngfDrop selectable [(file)]="addressDocumentFront" [accept]="'image/jpeg,image/png,application/pdf'"
        (fileChange)="onAddressFrontSelect($event)" class="document-front">
        <ng-container *ngIf="!!addressDocumentFront; else uploadIcon">
          <img *ngIf="addressDocumentFront.type !== 'application/pdf'"
            [ngfSrc]="addressDocumentFront" class="document" />

          <ng-container *ngIf="isBrowser">
            <app-pdf-viewer
              *ngIf="addressDocumentFront.type === 'application/pdf'"
              [file]="addressPdfDocumentFront">
            </app-pdf-viewer>
          </ng-container>
        </ng-container>

        </div>
        <p class="text-center">{{translationScope+'.frontpage' | transloco}} (PDF, JPG {{translationScope+'.or' | transloco}} PNG)</p>
      </div>


      <!-- <div ngfDrop selectable="1" multiple="1" [(file)]="addressDocumentBack"
      [(validDrag)]="validComboDrag"
      [(invalidDrag)]="invalidComboDrag"
      (fileChange)="onAddressBackSelect($event)"
      [ngClass]="{'goodDragClass':validComboDrag, 'badDragClass':invalidComboDrag}" class="col-6 col-md-5">
        <div class="document-back">
          <i *ngIf="!addressDocumentBack" class="far fa-plus-square" style="font-size: 36px; color: #ccc"></i>
          <img *ngIf="addressDocumentBack" [ngfSrc]="addressDocumentBack" />
        </div>
        <p>{{'backpage' | transloco}}</p>
      </div> -->
    </div>
    <div  class="row mb-3">
      <div class="col-12">
        <h5 class="note font-16 d-none d-lg-block d-md-block d-xl-block">{{translationScope+'.instructions.identity_verification_form.identity_verification_form_save_instruction' | transloco}}</h5>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!isTabReadOnly" class="row btn-control-group mt-3">
    <div class="col-6">
      <button (click)="onBackClick()" class="btn btn-primary form-control rounded-0" >
        {{translationScope+'.action_buttons.back' | transloco}}
      </button>
    </div>
    <div class="col-6">
      <button *ngIf="!kycDocuments.length" (click)="uploadDocument()" [disabled]="!localKycDocument.length" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.upload' | transloco}}
      </button>
      <button (click)="submitDocument()" *ngIf="hasPendingDocument" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.save_and_proceed' | transloco}}
      </button>
      <button *ngIf="isUpdate && !hasPendingDocument" (click)="formContinue()" class="btn btn-success form-control rounded-0" >
        {{translationScope+'.action_buttons.next' | transloco}}
      </button>
    </div>
  </div>
</form>

<ng-template #uploadIcon>
  <img class="icon-document-upload" src="assets/icons/photo-upload-icon.png" alt="">
</ng-template>
